<template>
    <div class="user-profile">
        <v-row v-if="user.avatar"
               justify="space-around">
            <v-col cols="auto" justify="center">
                <v-avatar size="155">
                    <img
                        :src="user.avatar"
                        :alt="user.first_name"
                    >
                </v-avatar>
            </v-col>
        </v-row>
        <v-row class="display-1" justify="center">
            Hello {{ user.first_name }}
        </v-row>
        <v-row class="font-weight-light" justify="center">
            {{ user.email }}
        </v-row>
    </div>
</template>

<script>
    import User from "../models/user";

    export default {
        name: "UserProfile",
        props: {
            user: User
        },
    }
</script>

<style scoped>

</style>
